import { __exports as tokenTypes } from "../../../../../../_virtual/tokenTypes.js";
var hasRequiredTokenTypes;
function requireTokenTypes() {
  if (hasRequiredTokenTypes) return tokenTypes;
  hasRequiredTokenTypes = 1;
  tokenTypes.__esModule = true;
  tokenTypes.word = tokenTypes.tilde = tokenTypes.tab = tokenTypes.str = tokenTypes.space = tokenTypes.slash = tokenTypes.singleQuote = tokenTypes.semicolon = tokenTypes.plus = tokenTypes.pipe = tokenTypes.openSquare = tokenTypes.openParenthesis = tokenTypes.newline = tokenTypes.greaterThan = tokenTypes.feed = tokenTypes.equals = tokenTypes.doubleQuote = tokenTypes.dollar = tokenTypes.cr = tokenTypes.comment = tokenTypes.comma = tokenTypes.combinator = tokenTypes.colon = tokenTypes.closeSquare = tokenTypes.closeParenthesis = tokenTypes.caret = tokenTypes.bang = tokenTypes.backslash = tokenTypes.at = tokenTypes.asterisk = tokenTypes.ampersand = void 0;
  var ampersand = 38;
  tokenTypes.ampersand = ampersand;
  var asterisk = 42;
  tokenTypes.asterisk = asterisk;
  var at = 64;
  tokenTypes.at = at;
  var comma = 44;
  tokenTypes.comma = comma;
  var colon = 58;
  tokenTypes.colon = colon;
  var semicolon = 59;
  tokenTypes.semicolon = semicolon;
  var openParenthesis = 40;
  tokenTypes.openParenthesis = openParenthesis;
  var closeParenthesis = 41;
  tokenTypes.closeParenthesis = closeParenthesis;
  var openSquare = 91;
  tokenTypes.openSquare = openSquare;
  var closeSquare = 93;
  tokenTypes.closeSquare = closeSquare;
  var dollar = 36;
  tokenTypes.dollar = dollar;
  var tilde = 126;
  tokenTypes.tilde = tilde;
  var caret = 94;
  tokenTypes.caret = caret;
  var plus = 43;
  tokenTypes.plus = plus;
  var equals = 61;
  tokenTypes.equals = equals;
  var pipe = 124;
  tokenTypes.pipe = pipe;
  var greaterThan = 62;
  tokenTypes.greaterThan = greaterThan;
  var space = 32;
  tokenTypes.space = space;
  var singleQuote = 39;
  tokenTypes.singleQuote = singleQuote;
  var doubleQuote = 34;
  tokenTypes.doubleQuote = doubleQuote;
  var slash = 47;
  tokenTypes.slash = slash;
  var bang = 33;
  tokenTypes.bang = bang;
  var backslash = 92;
  tokenTypes.backslash = backslash;
  var cr = 13;
  tokenTypes.cr = cr;
  var feed = 12;
  tokenTypes.feed = feed;
  var newline = 10;
  tokenTypes.newline = newline;
  var tab = 9;
  tokenTypes.tab = tab;
  var str = singleQuote;
  tokenTypes.str = str;
  var comment = -1;
  tokenTypes.comment = comment;
  var word = -2;
  tokenTypes.word = word;
  var combinator = -3;
  tokenTypes.combinator = combinator;
  return tokenTypes;
}
export {
  requireTokenTypes as __require
};
//# sourceMappingURL=tokenTypes.js.map
